import chain_1 from "assets/icons/chains/1.png";
import chain_5 from "assets/icons/chains/5.png";
import chain_10 from "assets/icons/chains/10.png";
import chain_56 from "assets/icons/chains/56.png";
import chain_82 from "assets/icons/chains/82.png";
import chain_100 from "assets/icons/chains/100.png";
import chain_137 from "assets/icons/chains/137.png";
import chain_420 from "assets/icons/chains/420.png";
import chain_42161 from "assets/icons/chains/42161.png";
import chain_80001 from "assets/icons/chains/80001.png";
import chain_421613 from "assets/icons/chains/421613.png";
import chain_11155111 from "assets/icons/chains/11155111.png";

export const chainIcons = {
  1: chain_1,
  10: chain_10,
  137: chain_137,
  420: chain_420,
  42161: chain_42161,
  421613: chain_421613,
  5: chain_5,
  80001: chain_80001,
  56: chain_56,
  82: chain_82,
  100: chain_100,
  11155111: chain_11155111,
};
